<template>
	<div class="online-users">
		<div class="toolbar">
			<div><h2>在线用户</h2><span class="muted">当前在线会话 {{ rows.length }} 个 · 采样时间：{{ time(sampledAt) }}</span></div>
			<div class="actions">
				<el-switch v-model="autoRefresh" active-text="每 10 秒刷新" @change="schedule" />
				<el-button type="primary" size="small" icon="el-icon-refresh" :loading="loading" @click="refresh">刷新</el-button>
			</div>
		</div>
		<el-alert title="展示已登录且最近 90 秒收到页面心跳的会话；页面在前台可见时每 20 秒更新。关闭、隐藏页面或断网后自动超时下线。同一账号多次登录按会话分别显示。" type="info" :closable="false" show-icon />
		<el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
		<lcsj-filter :show-search="false">
			<el-form-item label="关键词："><el-input v-model="keyword" size="small" clearable placeholder="会话、账号、姓名、部门或 IP" prefix-icon="el-icon-search" @input="page = 1" /></el-form-item>
			<template #actions><span class="muted">匹配 {{ filtered.length }} 个会话</span></template>
		</lcsj-filter>
		<el-table v-loading="loading" :data="paged" border stripe empty-text="暂无在线用户" row-key="sessionId">
			<el-table-column type="index" label="序号" width="70" align="center" :index="rowIndex" />
			<el-table-column prop="sessionId" label="会话编号" min-width="220" show-overflow-tooltip />
			<el-table-column prop="userName" label="账号" min-width="110" show-overflow-tooltip />
			<el-table-column prop="name" label="姓名" min-width="100" />
			<el-table-column prop="department" label="部门" min-width="130" show-overflow-tooltip />
			<el-table-column prop="ip" label="主机 IP" min-width="145" show-overflow-tooltip />
			<el-table-column prop="location" label="登录地点" min-width="170" show-overflow-tooltip />
			<el-table-column prop="browser" label="浏览器" min-width="150" show-overflow-tooltip />
			<el-table-column prop="operatingSystem" label="操作系统" min-width="140" />
			<el-table-column label="登录时间" min-width="170"><template slot-scope="scope">{{ time(scope.row.loginTime) }}</template></el-table-column>
			<el-table-column label="最后活动时间" min-width="170"><template slot-scope="scope">{{ time(scope.row.lastSeen) }}</template></el-table-column>
		</el-table>
		<el-pagination class="pagination" :current-page.sync="page" :page-size="20" :total="filtered.length" layout="total, prev, pager, next" />
	</div>
</template>

<script>
import { reqF } from "@/api/axiosFun";
import { reportOnlinePresence } from "@/utils/onlinePresence";
export default {
	name: "OnlineUsers",
	data: () => ({ rows: [], sampledAt: "", keyword: "", page: 1, loading: false, error: "", autoRefresh: true, timer: null, active: false }),
	computed: {
		filtered() {
			const value = this.keyword.trim().toLowerCase();
			return this.rows.filter(row => [row.sessionId, row.userName, row.name, row.department, row.ip].some(x => String(x || "").toLowerCase().includes(value)));
		},
		paged() { return this.filtered.slice((this.page - 1) * 20, this.page * 20); }
	},
	mounted() { this.activate(); },
	activated() { this.activate(); },
	deactivated() { this.stop(); },
	beforeDestroy() { this.stop(); },
	methods: {
		rowIndex(index) { return (this.page - 1) * 20 + index + 1; },
		activate() { if (this.active) return; this.active = true; this.refresh(); this.schedule(); },
		stop() { this.active = false; clearInterval(this.timer); this.timer = null; },
		schedule() {
			clearInterval(this.timer);
			this.timer = this.autoRefresh && this.active ? setInterval(() => { if (!document.hidden) this.refresh(); }, 10000) : null;
		},
		time(value) { return value ? new Date(value).toLocaleString("zh-CN", { hour12: false }) : "—"; },
		async refresh() {
			if (this.loading) return;
			this.loading = true;
			try {
				await reportOnlinePresence();
				const result = await reqF("post", "/api/sysConfig/OnlineUsers/GetList", {});
				if (result.code !== 1) throw new Error(result.msg || "获取在线用户失败");
				this.rows = result.data.users || [];
				this.sampledAt = result.data.sampledAt;
				this.page = Math.min(this.page, Math.max(1, Math.ceil(this.filtered.length / 20)));
				this.error = "";
			} catch (error) {
				this.rows = []; this.sampledAt = "";
				this.error = error.message || "获取在线用户失败，请重试";
			} finally { this.loading = false; }
		}
	}
};
</script>

<style scoped>
.online-users { padding: 20px; color: var(--app-text); background: var(--app-surface); min-height: 100%; box-sizing: border-box; }
.toolbar, .actions { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.toolbar { justify-content: space-between; margin-bottom: 18px; }
h2 { margin: 0 0 8px; font-size: 20px; }
.muted { color: var(--app-text-secondary); font-size: 13px; }
.pagination { margin-top: 18px; text-align: right; }
.el-alert + .el-alert { margin-top: 12px; }
</style>
